/**
 * Canonical public site URL. Must match the custom domain used for Merchant
 * Center, Search Console, and ad landing pages — never the *.web.app fallback
 * once the custom domain is live.
 */
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL ||
  'https://veraelegance.com'
).replace(/\/$/, '');

export const SITE_NAME = 'VERA by Kamakshi';

/** Approved brand copy — curated/imported model (never claim "handcrafted"). */
export const SITE_TAGLINE = 'Luxury Bags & Accessories — Modern Everyday Luxury';
export const SITE_TITLE = `${SITE_NAME} - ${SITE_TAGLINE}`;
export const SITE_DESCRIPTION =
  'Discover exquisite curated luxury handbags, clutches, totes, and wallets. Modern Everyday Luxury — premium quality with timeless elegance. Free shipping across India.';
export const SITE_KEYWORDS =
  'luxury handbags, curated bags, designer bags, clutches, totes, wallets, premium accessories, VERA by Kamakshi, Modern Everyday Luxury, luxury fashion';

/** Default Open Graph / Twitter share image (1200×630 JPG). */
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-default.jpg`;

/**
 * Real brand social profiles. Leave blank until the live URL is known —
 * empty entries are omitted from the footer/contact UI (never link to
 * facebook.com / instagram.com homepages).
 */
export const SOCIAL_LINKS = [
  {
    id: 'instagram',
    label: 'Instagram',
    href: (process.env.REACT_APP_INSTAGRAM_URL || '').trim()
  },
  {
    id: 'facebook',
    label: 'Facebook',
    href: (process.env.REACT_APP_FACEBOOK_URL || '').trim()
  },
  {
    id: 'pinterest',
    label: 'Pinterest',
    href: (process.env.REACT_APP_PINTEREST_URL || '').trim()
  },
  {
    id: 'x',
    label: 'X',
    href: (process.env.REACT_APP_X_URL || '').trim()
  }
].filter((link) => /^https?:\/\//i.test(link.href));

export { CANONICAL_HOST, LEGACY_HOSTS, redirectToCanonicalHost, buildProductSeo } from '../utils/seo';
